<mat-expansion-panel class="w-100"
                     [expanded]="isExpanded"
                     (opened)="isExpanded = true"
                     (closed)="isExpanded = false">
    <mat-expansion-panel-header class="w-100"
                                fxLayout="start space-between">
        <mat-panel-title class="no-wrap t2-semi-bold">
            <div class="radius-4 bc-primary-green-100 c-primary-gray-900 pl-12 pr-12">
                {{ 'i18n_af_labelIncidentTransactionIndex' | translate: {index: index} }}
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    @if (isExpanded) {
        <mat-tab-group mat-align-tabs="start" animationDuration="0"
                       class="w-100 h-100 hide-scroll-bar"
                       [(selectedIndex)]="selectedTabIndex">
            @for (tab of tabs; track tab) {
                <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                    <ng-template matTabContent>
                        @if (tab === 'tabTransactionCommon') {
                            <af-transaction-details-tab [transaction]="transaction" [incidentTypeCode]="incidentTypeCode" class="w-100"/>
                        }
                        @if (tab === 'tabTransactionPaymentInfo') {
                            <af-transaction-payment-info-tab [transaction]="transaction" class="w-100"/>
                        }
                        @if (tab === 'tabTransactionCreditInfo') {
                            <af-transaction-credit-info-tab [transaction]="transaction" class="w-100"/>
                        }
                        @if (tab === 'tabTransactionDroppers') {
                            <af-transaction-droppers-tab/>
                        }
                        @if (tab === 'tabTransactionHistory') {
                            <div class="w-100 transaction-history-tab">
                                <af-entity-history [entityId]="transaction.id!" [entityType]="EntityType.TRANSACTION" mode="full"/>
                            </div>
                        }
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>
    }
</mat-expansion-panel>
